import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOilDayCheckList, updateOilDayCheck, updateOilDayTask, downloadOilCheckDay } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import { mapGetters } from "vuex";
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'BairunOilDayCheck',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].statAbbr;
        }
      }

      return '';
    },
    getSellerName: function getSellerName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  data: function data() {
    return {
      listApi: getOilDayCheckList,
      type: '',
      showSelSeller: false,
      oilCodeDict: [],
      merge: [],
      // 存放需要合并的行
      mergeRowIndex: '',
      // 需要合并行下标
      dialogVisible: false,
      formData: {
        stationId: '',
        startDate: '',
        endDate: ''
      },
      searchInfo: {
        stationId: '',
        month: new Date().Format('yyyy-MM-dd 00:00:00'),
        startDate: DateUtil.monthStartStr(),
        endDate: DateUtil.yesterdayEndStr()
      },
      startTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !(time.getTime() >= new Date(DateUtil.monthStartStr(_this.searchInfo.startDate)) && time.getTime() <= new Date(new Date().Format('yyyy-MM-dd 23:59:59')));
        }
      },
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !(time.getTime() >= new Date(_this.searchInfo.startDate) && time.getTime() <= new Date(new Date().Format('yyyy-MM-dd 23:59:59')));
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');
              _context2.next = 3;
              return getDict('oilCode');

            case 3:
              _this2.oilCodeDict = _context2.sent;

              _this2.init();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.asyncStations.length) {
                  _this3.searchInfo.stationId = _this3.asyncStations[0].ID;
                }

                _this3.onSubmit();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.showSelSeller = false;
      this.page = 1;
      this.pageSize = 10;

      if (this.searchInfo.oilCode === '') {
        delete this.searchInfo.oilCode;
      }

      this.getTableData();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var page, pageSize, searchInfo, table;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this4.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this4.pageSize;
                searchInfo = {
                  stationId: _this4.searchInfo.stationId,
                  dataType: 'financeDetail',
                  month: new Date(_this4.searchInfo.month).Format('yyyyMM'),
                  startDate: new Date(_this4.searchInfo.startDate).Format('yyyyMMdd'),
                  endDate: new Date(_this4.searchInfo.endDate).Format('yyyyMMdd'),
                  oilCode: _this4.searchInfo.oilCode
                };
                _context4.next = 5;
                return _this4.listApi(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, searchInfo));

              case 5:
                table = _context4.sent;

                if (table.code === 0 && table.data.list != null) {
                  _this4.total = table.data.total;
                  _this4.page = table.data.page;
                  _this4.pageSize = table.data.pageSize;

                  _this4.getSpanArr(table.data.list);

                  table.data.list.forEach(function (item) {
                    item.editAble = false;
                  });
                  _this4.tableData = table.data.list;

                  _this4.$forceUpdate();
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getSpanArr: function getSpanArr(data) {
      this.merge = [];
      this.mergeRowIndex = 0;

      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.merge.push(1);
          this.mergeRowIndex = 0;
        } else {
          if (data[i].oilCode === data[i - 1].oilCode) {
            this.merge[this.mergeRowIndex] += 1;
            this.merge.push(0);
          } else {
            this.merge.push(1);
            this.mergeRowIndex = i;
          }
        }
      }
    },
    tableCellMerge: function tableCellMerge(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (['oilCode'].includes(column.property)) {
        var _row = this.merge[rowIndex];

        var _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    onMonthChange: function onMonthChange() {
      // 当月
      if (new Date(this.searchInfo.month).getMonth() == new Date().getMonth()) {
        this.searchInfo.startDate = DateUtil.monthStartStr(this.searchInfo.month);
        this.searchInfo.endDate = DateUtil.yesterdayEndStr();
      } else {
        this.searchInfo.startDate = DateUtil.monthStartStr(this.searchInfo.month);
        this.searchInfo.endDate = DateUtil.monthEndStr(this.searchInfo.month);
      }

      this.onSubmit();
    },
    onUpdate: function onUpdate(row) {
      row.rowTemp = JSON.parse(JSON.stringify(row));
      row.editAble = true;
    },
    onCancel: function onCancel(row) {
      Object.assign(row, row.rowTemp);
      row.editAble = false;
      delete row.rowTemp;
    },
    onSave: function onSave(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                delete row.rowTemp;
                _context5.next = 3;
                return updateOilDayCheck(row);

              case 3:
                res = _context5.sent;

                if (res.code == 0) {
                  _this5.$message({
                    type: 'success',
                    message: '保存成功！'
                  });

                  _this5.getTableData();
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onRecompute: function onRecompute() {
      this.formData.stationId = this.searchInfo.stationId;
      this.dialogVisible = true;
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.formData = {
        stationId: '',
        startDate: '',
        endDate: ''
      };
    },
    enterDialog: function enterDialog() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = {
                  'stationId': _this6.formData.stationId,
                  'startDate': Number(_this6.formData.startDate),
                  'endDate': Number(_this6.formData.endDate)
                };

                if (param.stationId) {
                  _context6.next = 4;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '油站不能为空！'
                });

                return _context6.abrupt("return");

              case 4:
                if (param.startDate) {
                  _context6.next = 7;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '开始时间不能为空！'
                });

                return _context6.abrupt("return");

              case 7:
                if (param.endDate) {
                  _context6.next = 10;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '结束时间不能为空！'
                });

                return _context6.abrupt("return");

              case 10:
                _context6.next = 12;
                return updateOilDayTask(param);

              case 12:
                res = _context6.sent;

                if (res.code == 0) {
                  _this6.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  _this6.closeDialog();

                  _this6.getTableData();
                }

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onExport: function onExport() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                param = {
                  stationId: _this7.searchInfo.stationId,
                  month: Number(new Date(_this7.searchInfo.month).Format('yyyyMM')),
                  startDate: Number(new Date(_this7.searchInfo.startDate).Format('yyyyMMdd')),
                  endDate: Number(new Date(_this7.searchInfo.endDate).Format('yyyyMMdd'))
                };

                if (_this7.searchInfo.oilCode !== undefined && _this7.searchInfo.oilCode !== '') {
                  param.oilCode = Number(_this7.searchInfo.oilCode);
                }

                _context7.next = 4;
                return downloadOilCheckDay(param);

              case 4:
                res = _context7.sent;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  }
};